import React, { FC } from 'react';
import { PlcColor } from '@styles/colors';

export const BarIcon: FC<{ color: PlcColor; isBig?: boolean }> = ({ color, isBig }) => {
  return <div style={{ background: color, height: isBig ? 12 : 6, width: 24 }} />;
};

export const DottedBarIcon: FC<{ color: PlcColor }> = ({ color }) => {
  return (
    <div className="flex" style={{ height: 6 }}>
      <div style={{ background: color, marginRight: 3, width: 6 }} />
      <div style={{ background: color, marginRight: 3, width: 6 }} />
      <div style={{ background: color, width: 6 }} />
    </div>
  );
};
